<template>
  <div>
    <v-card v-if="results.length >= 1 || results.length === null">
      <v-card-title class="text-25-security green-security font-weight-bold">
        <img src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/bars-solid.svg" alt="" class="icon-menu">
        Menú
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          :label="message()"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="results"
        :search="search"
        disable-initial-sort
        class="elevation-1 data-table-menu"
        no-data-text="Su búsqueda no dió resultados"
        rows-per-page-text="Filas por página"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.title }}</td>
          <td class="text-xs-right">{{ props.item.description }}</td>
          <td class="text-xs-right">
            <a :href="props.item.link" v-if="props.item.link.includes('http')">Seleccionar</a>
            <a :href="`#/` + props.item.link" v-if="!props.item.link.includes('http')">Seleccionar</a>
          </td>
        </template>
        <v-layout slot="no-results">
          <v-flex sm12>
            <v-card flat>
              <v-layout align-center justify-center row wrap fill-height>
                <v-flex
                  sm12
                  class="text-29-security text-md-center font-weight-bold"
                  style="color: #525252"
                >Su búsqueda "{{ search }}" no arrojó resultados.</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  data(){
    return{
      search: ""
    }
  },
  props: {
    results: {
      type: Array,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    headers: {
      type: Array,
      required: false
    }
  },
  methods: {
    message() {
      return `Mostrando resultados para ${this.$route.params.query}`;
    }
  }
}
</script>

<style>
.data-table-menu tr {
  cursor: default;
}

.theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
  background: #e0f4ba;
}
.icon-menu{
  width: 36px;
  height: 28px;
  opacity: 0.54;
}
</style>